import { fetchOnePricings } from './../../../requests'

export const funcGetOnePricings = async (resource, params) => {
  const [, data] = await fetchOnePricings(params.id)
  return { data: data.rows }
}
